module.exports = __webpack_public_path__ + "static/img/otsar.6c919f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-30/otsar.png
// module id = khoE
// module chunks = 6